module.exports = __webpack_public_path__ + "media/images/work_phone-bd952dc9735106bb8978d11508ae7a36.png";